$(document).ready(function() {
  $('.input-group > input').on('focus', function() {
    $(this).parent().addClass('input-group-focus');
  }).on('blur', function() {
    $(this).parent().removeClass('input-group-focus');
  });

  const selectors = $('.radio-block, .select-display-file .form-check');
  selectors.each(function() {
    const input = $(this).find('input');

    input.on('click', function(){
      selectors.removeClass('active');

      if($(this).is(':checked')) {
        $(this).parent().addClass('active');
      }
    });
  });
});
